import { formatCatalogValue } from "context/catalogUnits";
import { orderedEntries } from "context/limitsCatalog";

/** The Show toggles, in drawing order, with the noun the no-match message uses for each. */
export const SHOWS = [
  { key: "all", label: "All", noun: "limits" },
  { key: "changed", label: "Changed", noun: "changed limits" },
  { key: "held", label: "In use", noun: "limits in use" },
  { key: "fixed", label: "Fixed", noun: "fixed limits" },
];

const OVERRIDES = new Set(["user", "org", "blob"]);

const textOf = (value) => (undefined === value || null === value ? "" : String(value));

/** A query as lower-cased words; a blank query has none. */
export function filterTerms(query) {
  return textOf(query).toLowerCase().split(/\s+/).filter(Boolean);
}

/** Whether every word occurs in the row's label, id, description or shown value, or its group's label or key. */
export function matchesTerms(group, item, terms) {
  if (!terms.length) return true;
  const text = [group.label, group.group, item.label, item.id, item.description,
    formatCatalogValue(item.unit, item.value)].map(textOf).join("\n").toLowerCase();
  return terms.every((term) => text.includes(term));
}

/** Whether a row belongs under a Show toggle. */
export function matchesShow(item, show) {
  switch (show) {
    case "changed":
      return OVERRIDES.has(item.source);
    case "held":
      return "held" in item && null !== item.held;
    case "fixed":
      return true === item.fixed;
    default:
      return true;
  }
}

/**
 * The served groups narrowed by a query and a Show toggle. `matches` holds each group with a matching row and those
 * rows in drawing order, `counts` what each toggle would show for the query, and `total` every row served.
 */
export function filterLimits(groups, query, show) {
  const terms = filterTerms(query);
  const filtering = terms.length > 0 || "all" !== show;
  const counts = Object.fromEntries(SHOWS.map(({ key }) => [key, 0]));
  const matches = [];
  let total = 0;
  groups.forEach((group) => {
    const entries = orderedEntries(group);
    total += entries.length;
    const found = entries.filter((item) => matchesTerms(group, item, terms));
    SHOWS.forEach(({ key }) => { counts[key] += found.filter((item) => matchesShow(item, key)).length; });
    const rows = found.filter((item) => matchesShow(item, show));
    // Unfiltered, every served group keeps its card, even one with no rows.
    if (!filtering) matches.push({ group, rows: entries });
    else if (rows.length) matches.push({ group, rows });
  });
  return { terms, filtering, total, counts, matches };
}
